import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getAllRevisionsQuery } from './query.get-all.js';
import { deleteRevisionRequest } from './request.delete.js';

function useDeleteRevisionMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(deleteRevisionMutation(client, notifier, user));
}
const deleteRevisionMutation = (client, notifier, user) => {
  return {
    mutationKey: ["course-revisions/delete", user?.id],
    mutationFn: async revision => await deleteRevisionRequest(user, revision),
    onMutate: async input => {
      const data = client.getQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId: input.courseId
      }));
      const deletedAtIndex = data?.findIndex(it => it.id === input.id);
      client.setQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId: input.courseId
      }), previous => previous?.filter(revision => revision.id !== input.id));
      await client.cancelQueries({
        queryKey: getAllRevisionsQuery.queryKey({
          user,
          courseId: input.courseId
        })
      });
      return {
        deleted: input,
        index: deletedAtIndex !== -1 ? deletedAtIndex : undefined
      };
    },
    onSuccess: () => {
      notifier.notify({
        id: "course-revisions.delete",
        type: "success",
        body: "Versionen er blevet slettet"
      });
    },
    onError: (error, input, context) => {
      notifier.notify({
        id: "course-revisions.delete.error",
        type: "error",
        body: "Versionen kunne ikke slettes. Prøv igen om lidt."
      });
      client.setQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId: input.courseId
      }), previous => {
        if (!context) {
          return previous;
        }
        const next = [...(previous ?? [])];
        if (context?.index) {
          next.splice(context.index, 0, context.deleted);
        } else {
          next.push(context.deleted);
        }
        return next;
      });
    }
  };
};

export { useDeleteRevisionMutation };
//# sourceMappingURL=mutation.delete.js.map
